import { useEffect } from 'react';
import './ShopModal.css';

function ShopModal({ onClose }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  return (
    <div className="shop-modal__backdrop" onClick={onClose}>
      <div className="shop-modal__panel" onClick={(e) => e.stopPropagation()}>
        <button className="shop-modal__close" onClick={onClose} aria-label="Schließen">✕</button>
        <span className="shop-modal__label">Weinshop</span>
        <h2 className="shop-modal__title">Coming Soon</h2>
        <div className="shop-modal__divider" />
        <p className="shop-modal__text">
          Unser Online-Weinshop befindet sich derzeit im Aufbau.<br />
          Bald können Sie unsere über 2400 ausgewählten Weine bequem nach Hause bestellen.
        </p>
        <a href="mailto:genuss@rocaille.de" className="shop-modal__btn" onClick={onClose}>
          Benachrichtigung anfragen
        </a>
      </div>
    </div>
  );
}

export default ShopModal;
